import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Main from '@/views/Main.vue'
import Login from '@/views/Login.vue'
import NotFind from '@/views/notFind'
import AppList from '@/views/app_list.vue'
import AppNew from '@/views/app_new'
import AppEdit from '@/views/app_edit'
import MuLuList from '@/views/MuLu'
import WenDangList from '@/views/wendang_list.vue'
import WenDangNew from '@/views/wendang_new.vue'
import WenDangEdit from '@/views/wendang_edit.vue'
import Index from '@/views/Index.vue'
import UserList from '@/views/user_list'
import UserNew from '@/views/user_new'
import UserEdit from '@/views/user_edit'
import View from '@/views/help_view'
import Search from '@/views/help_search'

Vue.use(VueRouter)

// 解决重复点击链接的报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err)
}

export default new VueRouter({
  mode: 'history',
  routes:[
  {
    path: '/',
    name: 'Home',
    hidden: true,
    component: Index
  },
  {
    path: '/manage',
    name: 'Manage',
    component: Home,
		redirect: '/main',
		meta: {
			title: '帮助文档',
			notLogin: true,
			hidden: true,
		},
		children: [
		  {
		    path: '/main',
		    name: 'Main',
		    hidden: true,
		    component: Main,
		    meta: {
		      title: '首页'
		    }
		  },
		  {
		    path: '/user',
		    name: 'User',
		    component: UserList,
		    meta: {
		      title: '用户管理'
		    }
		  },
		  {
		    path: '/user/:type',
		    name: 'UserNew',
		    component: UserNew,
		  	hidden: true,
		    meta: {
		      title: '用户管理'
		    }
		  },
		  {
		    path: '/user/:type/:id',
		    name: 'UserEdit',
		    component: UserEdit,
		    hidden: true,
		    meta: {
		      title: '用户管理'
		    }
		  },
		  {
		    path: '/app',
		    name: 'AppList',
		    hidden: false,
		    component: AppList,
		    meta: {
		      title: '应用管理'
		    }
		  },
		  {
		    path: '/app/:type',
		    name: 'AppNew',
		    component: AppNew,
		  	hidden: true,
		    meta: {
		      title: '应用管理'
		    }
		  },
		  {
		    path: '/app/:type/:id',
		    name: 'AppEdit',
		    component: AppEdit,
		    hidden: true,
		    meta: {
		      title: '应用管理'
		    }
		  },
		  {
		    path: '/mulu',
		    name: 'MuLuList',
		    hidden: false,
		    component: MuLuList,
		    meta: {
		      title: '帮助目录管理'
		    }
		  },
		  {
		    path: '/webdanglist',
		    name: 'WenDangList',
		    hidden: false,
		    component: WenDangList,
		    meta: {
		      title: '文档管理'
		    }
		  },
		  {
		    path: '/webdanglist/:type/:appid/:mlid',
		    name: 'WenDangNew',
		    component: WenDangNew,
		  	hidden: true,
		    meta: {
		      title: '文档管理'
		    }
		  },
		  {
		    path: '/webdanglist/:type/:id',
		    name: 'WenDangEdit',
		    component: WenDangEdit,
		    hidden: true,
		    meta: {
		      title: '文档管理'
		    }
		  },
		  
		]
  },
	{
	  path: '/login',
	  name: 'Login',
	  hidden: true,
	  component: Login
	},
	{
	  path: '/view/:uuid',
	  name: 'view',
	  hidden: true,
	  component: View
	},
	{
	  path: '/search/:appid/:leixing/:keyword',
	  name: 'search',
	  hidden: true,
	  component: Search
	},
	{
	  path: '/search/:appid/:leixing',
	  name: 'search',
	  hidden: true,
	  component: Search
	},
	{
	  path: '/404',
	  name: '404',
	  hidden: true,
	  component: NotFind
	}
]
  
})
